import { BuildMode } from "@/types";

export enum GtmEvent {
  RegistrationDone = "registration_done",
}

type GtmEventPayload = {
  event: GtmEvent;
  [key: string]: unknown;
};

const isTrackingAllowed = (): boolean => {
  const allowedModes = [BuildMode.Production];
  const mode = import.meta.env.MODE as BuildMode;
  return allowedModes.includes(mode);
};

export const trackEvent = (payload: GtmEventPayload): void => {
  if (!isTrackingAllowed()) {
    return;
  }
  if (!Array.isArray(window.dataLayer)) {
    console.warn("GTM dataLayer not found.");
    return;
  }
  window.dataLayer.push(payload);
  if (payload.event === GtmEvent.RegistrationDone) {
    window.gtag?.("event", "conversion", { send_to: "AW-16714161893/FxbOCIGTq_MZEOW996E-" });
  }
};
